import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { map, take } from 'rxjs/operators';

export const unauthGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.gigyaUser$.pipe(
    take(1),
    map(user => {
      if(user && Object.keys(user).length > 0) {
        return router.createUrlTree(['/home']);
      }
      return true;
    })
  );
};